import { useEffect, useState } from "react";
import ApiServices from "../../config/ApiServices";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, showLoader } from "../../redux/actions/LoaderActions";
import Loader from "../../utils/Loader";
import { showModal } from "../../redux/actions/ModalActions";
import ModalManager from "../../Modals/ModalManager";
import { useParams } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import { Link } from "react-router-dom";
import Pagination from "../../utils/Pagination";
import * as qs from "qs";
import { setData } from "../../redux/actions/DataAction";

export default function ManageTask({ title }) {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.loader.loading);
  const isOpen = useSelector((state) => state.modal.isOpen);
  const [status, setStatus] = useState(true);
  const { batchId } = useParams();
  const [tasks, setTasks] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalData, setTotalData] = useState(0);
  const [type, setType] = useState("");
  const [trainerMap, setTrainerMap] = useState({}); // store trainerId → trainerName

  // fetch trainer names by IDs
  const fetchTrainers = async (trainerIds) => {
    if (!trainerIds || trainerIds.length === 0) return;
    try {
      const res = await ApiServices.apiRequest("getSingleTrainer", {
        id: trainerIds,
      });
      if (res.data.success) {
        const map = {};
        res.data.data.forEach((tr) => {
          map[tr._id] = tr.name;
        });
        setTrainerMap((prev) => ({ ...prev, ...map }));
      }
    } catch (err) {
      console.error("Error fetching trainers", err);
    }
  };

  useEffect(() => {
    if (isOpen == false) {
      dispatch(showLoader());
      setTasks([]);
      let data = {
        batchId: batchId,
        limit: itemsPerPage,
        pageno: currentPage + 1,
        status: status,
      };
      if (!!type) {
        data.taskType = type;
      }
      ApiServices.apiRequest("getTaskPagination", data)
        .then(async (res) => {
          if (res.data.success) {
            setTotalData(res.data.total ? res.data.total : 0);
            setTasks(res.data.data);
            console.log("the data is", res.data.data);

            // collect all trainerIds from tasks → batch → trainerId
            let allTrainerIds = [];
            res.data.data.forEach((task) => {
              if (task?.batchId?.trainerId?.length) {
                allTrainerIds.push(...task.batchId.trainerId);
              }
            });
            allTrainerIds = [...new Set(allTrainerIds)]; // unique
            await fetchTrainers(allTrainerIds);
          } else {
            console.log(res.data.message);
          }
        })
        .catch((err) => {
          toast.error(err?.message ? err?.message : "Something went wrong");
        })
        .finally(() => {
          dispatch(hideLoader());
        });
    }
  }, [isOpen, status, currentPage, itemsPerPage, batchId, type]);

  const removeTask = (id, taskStatus) => {
    let data = {
      _id: id,
      status: !taskStatus,
    };
    dispatch(
      showModal("StatusModal", data, "changeStatusAssignTask", "remove")
    );
  };

  const addBackTask = (id, taskStatus) => {
    let data = {
      _id: id,
      status: !taskStatus,
    };
    dispatch(
      showModal("StatusModal", data, "changeStatusAssignTask", "addBackTask")
    );
  };

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  const handleStatusChange = (event) => {
    setStatus(JSON.parse(event.target.value)); // Ensure the value is parsed as boolean
  };

  return (
    <>
      <div className="container">
        <div className="page-inner">
          {loading && !isOpen ? (
            <Loader />
          ) : (
            <>
              <div className="align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
                <div>
                  <h3 className="fw-bold mb-3">{title}</h3>
                </div>
                <div className="d-flex justify-content-between ">
                  <select
                    className="form-select me-2 w-25"
                    onChange={(e) => {
                      setType(e.target.value);
                    }}
                    value={type}
                  >
                    <option value={""}>All</option>
                    <option value={1}>Assignments</option>
                    <option value={2}>Tests</option>
                  </select>
                  <div className="w-75 d-flex justify-content-end">
                    <select
                      className="form-select me-2 w-25"
                      onChange={handleStatusChange}
                      value={status}
                    >
                      <option value={true}>Current</option>
                      <option value={false}>Removed</option>
                    </select>
                    <button
                      onClick={() => {
                        dispatch(showModal("AssignTask"));
                      }}
                      className="btn btn-primary btn-round"
                    >
                      Assign Task
                    </button>
                  </div>
                </div>
              </div>
              <div className="container">
                <div className="row">
                  {tasks?.length > 0 ? (
                    tasks.map((task, index) => (
                      <div className="col-sm-12 text-capitalize" key={index}>
                        <Link
                          to={`/trainer/marks/${batchId}/${task?._id}`}
                          className="text-dark"
                        >
                          <div className="d-flex align-items-center justify-content-between">
                            <div>
                              <div>{task?.name}</div>
                              <span className="text-muted">
                                MM :{task?.maximumMarks}
                              </span>
                              <br />

                              {/* Show trainer name directly from task.trainerId */}
                              {task?.trainerId?.name && (
                                <span className="text-info">
                                  Posted By: {task.trainerId.name}
                                </span>
                              )}
                              <br />
                            </div>
                            <div>
                              <div className="d-flex align-items-center justify-content-end">
                                <span className="text-muted">
                                  Due : {task?.date}
                                </span>
                                <div className="dropdown">
                                  <IconButton
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <MoreVertIcon />
                                  </IconButton>
                                  <ul className="dropdown-menu">
                                    {status ? (
                                      <li>
                                        <a
                                          className="dropdown-item"
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            removeTask(task?._id, task?.status);
                                          }}
                                        >
                                          Remove
                                        </a>
                                      </li>
                                    ) : (
                                      <li>
                                        <a
                                          className="dropdown-item"
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            addBackTask(
                                              task?._id,
                                              task?.status
                                            );
                                          }}
                                        >
                                          Add Back
                                        </a>
                                      </li>
                                    )}
                                    <li>
                                      <a
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          dispatch(
                                            showModal("EditTask", {
                                              _id: task?._id,
                                            })
                                          );
                                        }}
                                        className="dropdown-item"
                                        href="#"
                                      >
                                        Edit
                                      </a>
                                    </li>
                                    <li>
                                      <Link
                                        to={`/trainer/marks/${batchId}/${task?._id}`}
                                        className="dropdown-item"
                                      >
                                        View
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        to={`/trainer/submission/${batchId}/${task?._id}`}
                                        className="dropdown-item"
                                      >
                                        View Submissions
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div className="mt-0 ">
                                <span className="text-success">
                                  Assigned: {task?.totalAssigned}
                                </span>{" "}
                                {","}
                                <span className="text-danger">
                                  Not Assigned: {task?.totalNotAssigned}
                                </span>
                              </div>
                            </div>
                          </div>
                        </Link>
                        <hr className="my-1" />
                      </div>
                    ))
                  ) : (
                    <h1>No Task Present!!</h1>
                  )}
                </div>
                <div className="d-flex justify-content-end">
                  <Pagination
                    count={totalData}
                    page={currentPage}
                    itemsPerPage={itemsPerPage}
                    onPageChange={handlePageChange}
                    onItemsPerPageChange={handleItemsPerPageChange}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
